import { features } from 'reactApp/mail-features';

// cloudweb-19905
export const overquotaFoldersConfig = features.getAsJSONWithDefaults('overquota-folders-config', {
    enabled: false,
    count: 4,
    url: 'https://e.mail.ru',
    tariffs: '20',
    activeTab: 'm',
} as {
    // фича включена?
    enabled: boolean;
    // количество папок в плашке
    count: number;
    // url который открывается по клику на папку "Почта"
    url: string;
    // набор тарифов
    tariffs: string;
    // выбранный тариф (m/y)
    activeTab: string;
});
